import React, { Component } from 'react';

import './style.css'

class AgeSelector extends Component {

  constructor() {
    super();
    this.onChange = this.onChange.bind(this);
  }
  
  onChange(e) {
    const value = e.target.value;
    setTimeout(() => this.props.onChange(value), 200)
  }

  render() {
    return <section className="container-fluid age-selector">
        <form onSubmit={(e) => e.preventDefault()}>
          <label htmlFor="age">Ingresá tu edad y mirá las becas que hay para vos</label>
          <input name="age" onInput={ this.onChange } type="number" min="0" />
        </form>
    </section>
  }
}

export default AgeSelector;


// WEBPACK FOOTER //
// ./src/components/AgeSelector/Component.js